import { PerformanceState, READ_PERFORMANCE_DATA_REQUEST, READ_PERFORMANCE_DATA_SUCCESS, READ_PERFORMANCE_DATA_FAILURE } from 'store/reducers/types/dashboard/performance';
import { PerformanceActionTypes } from "store/reducers/types/dashboard/performance";

const defaultState: PerformanceState = {
  isLoading: false,
  errorMessage: ""
};

export default function performance(state = defaultState, action: PerformanceActionTypes): PerformanceState {
  switch (action.type) {
    case READ_PERFORMANCE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_PERFORMANCE_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_PERFORMANCE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
